import api from '@/api';
import Cookies from 'js-cookie';
import { toClipboard } from '@soerenmartius/vue3-clipboard';
import mitt from 'mitt';
import { App } from 'vue';

export default function(app:App<Element>):void
{
    // 挂载通用API
    app.config.globalProperties.$api = api;
    app.config.globalProperties.$cookies = Cookies;
    app.config.globalProperties.$clipboard = toClipboard;
    app.config.globalProperties.$eventBus = mitt();

    // 挂载业务API
}
